<template>
  <div>
    <sys-header/>

    <div class="section">
      <slot />
    </div>

    <sys-footer/>
  </div>
</template>

<script>
import SysHeader from '@/components/layouts/Header'
import SysFooter from '@/components/layouts/Footer'

export default {
  components: {
    SysHeader,
    SysFooter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/DashboardLayout.vue